// reducer.js

import {
  FETCH_CUSTOMERS_REQUEST,
  FETCH_CUSTOMERS_SUCCESS,
  FETCH_CUSTOMERS_FAILURE,
  CREATE_CUSTOMER_REQUEST,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_FAILURE,
} from "../actions/customer";

const initialState = {
  customers: [],
  loading: false,
  error: null,
};

const customerReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_CUSTOMERS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CUSTOMERS_SUCCESS:
      return {
        ...state,
        loading: false,
        customers: action.payload,
      };
    case FETCH_CUSTOMERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case CREATE_CUSTOMER_REQUEST:
      return {
        ...state,
        creating: true,
        error: null,
      };
    case CREATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        creating: false,
        customers: [action.payload, ...state.customers],
      };
    case CREATE_CUSTOMER_FAILURE:
      return {
        ...state,
        creating: false,
        error: action.payload,
      };
    case UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        updating: true,
        error: null,
      };
    case UPDATE_CUSTOMER_SUCCESS:
      return {
        ...state,
        updating: false,
        customers: [
          ...state.customers.map((p) =>
            p.id !== action.payload.id ? p : action.payload
          ),
        ],
      };
    case UPDATE_CUSTOMER_FAILURE:
      return {
        ...state,
        updating: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default customerReducer;